import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PRE_ACTIVATION_YES_NO_OPTIONS } from "../../../utils/constants";
import {
  PRE_ACTIVATION_FIELD_AGENCY_BRAND_ASSETS_READY,
  PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_HINT_AGENCY_BRAND_ASSETS_READY,
  PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME,
} from "../../../i18n/keysTranslations";
import FieldBlock from "../components/FieldBlock";
import FieldError from "../components/FieldError";
import FieldHint from "../components/FieldHint";
import FieldLabel from "../components/FieldLabel";
import IntakeTextField from "../../../components/Form/IntakeTextField";
import RadioGroup from "../components/RadioGroup";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";

const AgencyLiveExerciseSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  const yesNoOptions = useMemo(
    () =>
      PRE_ACTIVATION_YES_NO_OPTIONS.map((option) => ({
        value: option.value,
        label: t(option.labelKey),
      })),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <FieldBlock>
        <FieldLabel
          htmlFor="sessionBrandName"
          text={t(PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME)}
          required
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME)} />
        <IntakeTextField
          name="sessionBrandName"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME)}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="brandAssetsReady"
          text={t(PRE_ACTIVATION_FIELD_AGENCY_BRAND_ASSETS_READY)}
          required
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_AGENCY_BRAND_ASSETS_READY)} />
        <Controller
          name="brandAssetsReady"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <RadioGroup
                name="brandAssetsReady"
                options={yesNoOptions}
                selectedValue={field.value}
                onChange={field.onChange}
                readOnly={readOnly}
              />
              <FieldError message={fieldState.error?.message} />
            </>
          )}
        />
      </FieldBlock>
    </ReadOnlySectionGrid>
  );
};

export default AgencyLiveExerciseSection;
